<template>
  <kst-page-export
    :catalog="DaiSearchCatalog"
    :params="Model.UrlParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :searchData="searchData"
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithReport"
      :label="Info.Export.Excel.Option.Report"
    />
  </kst-page-export>
</template>

<script>
import DaiSearchCatalog from "../DaiSearchCatalog.js";
import Info from "../DaiInfo.js";
import Model from "../DaiModel.js";
import Services from "../../../services/Api/DailyServices.js"; 

import Export from "./DaiEx_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    DaiSearchCatalog: DaiSearchCatalog,
    Info: Info,
    Model: Model,
    searchData: {
      Date: null,
      SearchResultID: null,
      WarehouseID: null
    },
    userData: {
      WithReport: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExport(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** by export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.userData.WithReport = true;
    },

    getListOptions() {
      return {
        date: this.$kst.Out.getDateString(this.searchData.Date),
        searchresult: this.$kst.Search.getValue(this.searchData.SearchResultID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID)
      };
    }
  }
}
</script>